import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AppService, CoreProxyService, CoreTypes, IncidentTypes, LabelValue } from 'common-cloudstudio';

@Component({
  selector: 'app-incident-contact-groups',
  templateUrl: './incident-contact-groups.component.html',
  styleUrls: ['./incident-contact-groups.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IncidentContactGroupsComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => IncidentContactGroupsComponent),
      multi: true,
    }
  ]
})
export class IncidentContactGroupsComponent implements OnInit, ControlValueAccessor {
  _data: IncidentTypes.ExternalInstantMessagingContact[] = [];
  @Input('data')
  set data(data: string) {
    this.writeValue(data);
  }
  get data() {
    return JSON.stringify(this._data);
  }

  isDisabled: boolean;
  onChange = (_:any) => { }
  onTouch = () => { }
  @Input() _optionsContacts: LabelValue<number>[] = [];
  @Input() contactsFullList: IncidentTypes.ExternalInstantMessagingContact[] = [];
  @Input() editing: boolean = false;
  _optionsGroup: LabelValue<number>[] = [];
  _selectedGroup: LabelValue<number>;
  _selectedContact: LabelValue<number>;
  selectedElements: any[] = [];
  _selectAllElements: boolean = false;
  _unCheckAllElements: boolean = false;

  constructor(
    public _appService: AppService,
    private _coreProxyService: CoreProxyService
  ) { }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  
  ngOnInit() { }

  public validate() { }

  onInput() {
    this.onTouch();
    this.onChange(this._data);
  }

  setEnableSwitch(element) {
    if(element.Checked) {
      this.selectedElements.push(element);
      if(this._unCheckAllElements) this._unCheckAllElements = false;
    } else {
      let index = this.selectedElements.findIndex(x => x === element);
      let indexData = this._data.findIndex(x => x === element);
      if(index > -1) {
        this.selectedElements.splice(index, 1);
      }
      if(indexData > -1) {
        this._data[indexData].Checked = false;
      }
    }
    this._selectAllElements = (this.selectedElements.length > 0 && this.selectedElements.length === this._data?.length)
    this.onInput();
    this.selectNotificationGroup(this._optionsContacts);
  }

  checkAll() {
    this.selectedElements = [];
    this._unCheckAllElements = false;
    this._data.forEach(contact => {
      if(contact.Enabled) {
        contact.Checked = this._selectAllElements;
      }
      if (this._selectAllElements)
        this.selectedElements.push(contact);
    });
    this.onInput();
    this.selectNotificationGroup(this._optionsContacts);
  }

  unCheckAll() {
    this.selectedElements = [];
    this._selectAllElements = false; 
    this._data.forEach(contact => {
      if(contact.Enabled) {
        contact.Checked = false
      }
    });
    this.onInput();
    this.selectNotificationGroup(this._optionsContacts);
  }

  writeValue(value: any): void {
    this.selectedElements = [];
    if (value && value.length !== 0) {
      this._data = JSON.parse(JSON.stringify(value));
      this._data.map(contact => {
        this.selectedElements.push(contact);
        this._selectAllElements = true;
      });
      this.selectNotificationGroup(this._optionsContacts);
    } else {
      this._data = [];
      this._selectedContact = this._optionsContacts[0];
    }
  }
  
  addContactGroup(contact) {
    if (contact && contact.value != 0) {   
      let exist = this.selectedElements.find(x => x.InstantMessagingContactID == contact?.value);
      if (!exist){
        let selectedGroup = this.contactsFullList.find(g => g.InstantMessagingContactID === contact?.value);
        if(!this.selectedElements.length) this.selectedElements = [];

        if(selectedGroup) {
          selectedGroup.Checked = true;
          selectedGroup.Enabled = true;
          this.selectedElements.push(selectedGroup);
          this._data.push(selectedGroup);
        }
      }
    }
    this._selectAllElements = (this.selectedElements.length > 0 && this.selectedElements.length === this._data?.length)
    this.onInput();
    this.selectNotificationGroup(this._optionsContacts)
  }

  selectNotificationGroup(contactList) {
    let exist =  this.selectedElements?.filter(x => contactList.find(l => l.value === x.InstantMessagingContactID));
    if(exist.length){
      this._optionsContacts.forEach(l => {        
        if(exist.find(x => x.InstantMessagingContactID === l.value)){
          l.disabled = true;
        } else {
          l.disabled = false;
        }
      });
    } else if(this.selectedElements?.length) {
      this._optionsContacts.forEach(l => {
        if(!this.selectedElements.find(x => x.InstantMessagingContactID === l.value)){
          l.disabled = false;
        }
      });
    }
    setTimeout(() => {
      this._selectedContact = this._optionsContacts[0];
    }, 100);
  }

}
